<template>
    <div class="page-container">
        <!-- BEGIN CONTENT -->
        <div class="page-content-wrapper">
            <!-- BEGIN CONTENT BODY -->
            <!-- BEGIN PAGE HEAD-->
            <div class="page-head">
                <div class="container-fluid">
                    <!-- BEGIN PAGE TITLE -->
                    <div class="page-title">
                        <h1>DSP Prepay
                            <!-- <small></small> -->
                        </h1>
                    </div>
                    <!-- END PAGE TITLE -->
                </div>
            </div>
            <!-- END PAGE HEAD-->
            <!-- BEGIN PAGE CONTENT BODY -->
            <div class="page-content">
                <div class="container-fluid">
                    <!-- BEGIN PAGE CONTENT INNER -->
                    <div class="page-content-inner">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="prepay-calc-wrap">
                                    <div class="top">
                                        <v-multiselect v-model="selectedDsp"
                                                       :options="listDsp"
                                                       class="input-small"
                                                       placeholder="All"
                                                       :multiple="false"
                                        />
                                    </div>
                                    <table>
                                        <thead>
                                            <tr>
                                                <th class="status">
                                                    <span class="wrap">
                                                        Status
                                                        <span class="sort-icon">
                                                            <svg class="up" width="4" height="3" viewBox="0 0 4 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M0.277602 2.79993L3.7224 2.79993C3.83859 2.79993 3.90618 2.66859 3.83864 2.57403L2.11625 0.162736C2.05927 0.082974 1.94073 0.082974 1.88375 0.162736L0.161356 2.57403C0.0938165 2.66859 0.161406 2.79993 0.277602 2.79993Z" fill="#8592A5"/>
                                                            </svg>
                                                            <svg class="down" width="4" height="3" viewBox="0 0 4 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M3.7224 0.200073H0.277602C0.161406 0.200073 0.0938167 0.331413 0.161356 0.425966L1.88375 2.83726C1.94073 2.91703 2.05927 2.91703 2.11625 2.83726L3.83864 0.425966C3.90618 0.331413 3.83859 0.200073 3.7224 0.200073Z" fill="#8592A5"/>
                                                            </svg>
                                                        </span>
                                                    </span>

                                                </th>
                                                <th class="name">
                                                    <span class="wrap">
                                                        Name
                                                        <span class="sort-icon">
                                                            <svg class="up" width="4" height="3" viewBox="0 0 4 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M0.277602 2.79993L3.7224 2.79993C3.83859 2.79993 3.90618 2.66859 3.83864 2.57403L2.11625 0.162736C2.05927 0.082974 1.94073 0.082974 1.88375 0.162736L0.161356 2.57403C0.0938165 2.66859 0.161406 2.79993 0.277602 2.79993Z" fill="#8592A5"/>
                                                            </svg>
                                                            <svg class="down" width="4" height="3" viewBox="0 0 4 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M3.7224 0.200073H0.277602C0.161406 0.200073 0.0938167 0.331413 0.161356 0.425966L1.88375 2.83726C1.94073 2.91703 2.05927 2.91703 2.11625 2.83726L3.83864 0.425966C3.90618 0.331413 3.83859 0.200073 3.7224 0.200073Z" fill="#8592A5"/>
                                                            </svg>
                                                        </span>
                                                    </span>
                                                </th>
                                                <th class="th">
                                                    <span class="wrap">
                                                        Prepay
                                                        <span class="sort-icon">
                                                            <svg class="up" width="4" height="3" viewBox="0 0 4 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M0.277602 2.79993L3.7224 2.79993C3.83859 2.79993 3.90618 2.66859 3.83864 2.57403L2.11625 0.162736C2.05927 0.082974 1.94073 0.082974 1.88375 0.162736L0.161356 2.57403C0.0938165 2.66859 0.161406 2.79993 0.277602 2.79993Z" fill="#8592A5"/>
                                                            </svg>
                                                            <svg class="down" width="4" height="3" viewBox="0 0 4 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M3.7224 0.200073H0.277602C0.161406 0.200073 0.0938167 0.331413 0.161356 0.425966L1.88375 2.83726C1.94073 2.91703 2.05927 2.91703 2.11625 2.83726L3.83864 0.425966C3.90618 0.331413 3.83859 0.200073 3.7224 0.200073Z" fill="#8592A5"/>
                                                            </svg>
                                                        </span>
                                                    </span>
                                                </th>
                                                <th class="th">
                                                    <span class="wrap">
                                                        Spend
                                                        <span class="sort-icon">
                                                            <svg class="up" width="4" height="3" viewBox="0 0 4 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M0.277602 2.79993L3.7224 2.79993C3.83859 2.79993 3.90618 2.66859 3.83864 2.57403L2.11625 0.162736C2.05927 0.082974 1.94073 0.082974 1.88375 0.162736L0.161356 2.57403C0.0938165 2.66859 0.161406 2.79993 0.277602 2.79993Z" fill="#8592A5"/>
                                                            </svg>
                                                            <svg class="down" width="4" height="3" viewBox="0 0 4 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M3.7224 0.200073H0.277602C0.161406 0.200073 0.0938167 0.331413 0.161356 0.425966L1.88375 2.83726C1.94073 2.91703 2.05927 2.91703 2.11625 2.83726L3.83864 0.425966C3.90618 0.331413 3.83859 0.200073 3.7224 0.200073Z" fill="#8592A5"/>
                                                            </svg>
                                                        </span>
                                                    </span>
                                                </th>
                                                <th class="th">
                                                    <span class="wrap">
                                                        Prepay left
                                                        <span class="sort-icon">
                                                            <svg class="up" width="4" height="3" viewBox="0 0 4 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M0.277602 2.79993L3.7224 2.79993C3.83859 2.79993 3.90618 2.66859 3.83864 2.57403L2.11625 0.162736C2.05927 0.082974 1.94073 0.082974 1.88375 0.162736L0.161356 2.57403C0.0938165 2.66859 0.161406 2.79993 0.277602 2.79993Z" fill="#8592A5"/>
                                                            </svg>
                                                            <svg class="down" width="4" height="3" viewBox="0 0 4 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M3.7224 0.200073H0.277602C0.161406 0.200073 0.0938167 0.331413 0.161356 0.425966L1.88375 2.83726C1.94073 2.91703 2.05927 2.91703 2.11625 2.83726L3.83864 0.425966C3.90618 0.331413 3.83859 0.200073 3.7224 0.200073Z" fill="#8592A5"/>
                                                            </svg>
                                                        </span>
                                                    </span>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td class="status">
                                                    <span class="red">Cap riched</span>
                                                </td>
                                                <td class="name">DSP Name</td>
                                                <td class="th prepay">
                                                     $ 10,000
                                                     <div class="edit-wrap">
                                                         <div class="drop">
                                                             <input type="text">
                                                             <div class="ok">
                                                                 <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M8.79496 15.875L4.62496 11.705L3.20496 13.115L8.79496 18.705L20.795 6.70498L19.385 5.29498L8.79496 15.875Z" fill="#27AE60"/>
                                                                </svg>

                                                             </div>
                                                             <div class="cancel">
                                                                 <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="#EB5757"/>
                                                                </svg>

                                                             </div>
                                                         </div>
                                                         <div class="icon">
                                                             <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M11.6366 1.86334L14.1366 4.36334L12.4499 6.05668L9.94995 3.55668L11.6366 1.86334ZM1.86328 14.1367V11.6367L9.23661 4.26335L11.7366 6.76335L4.36328 14.1367H1.86328Z" fill="#C2CAD8"/>
                                                            </svg>
                                                         </div>
                                                     </div>
                                                </td>
                                                <td class="th"> $ 1,000</td>
                                                <td class="th"> $ 9,000</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- END PAGE CONTENT INNER -->
                </div>
            </div>
            <!-- END PAGE CONTENT BODY -->
            <!-- END CONTENT BODY -->
        </div>
        <!-- END CONTENT -->
    </div>
</template>

<script>
    import ICountUp from 'vue-countup-v2';

    export default {
        name: "PrepayCalc",
        components: {
            ICountUp
        },
        data() {
            return {
                period: 'today',
                listDsp: [1,2],
                selectedDsp: null,
                delay: 1000,
                options: {
                    useEasing: true,
                    useGrouping: true,
                    separator: ',',
                    decimal: '.',
                    prefix: '',
                    suffix: ''
                },

                imprNowSum: 130500,
                profitNowSum: 30.02,
            }
        },
        methods: {
            onReady: function(instance, CountUp) {
                const that = this;
                instance.update(that.profitNowSum + 10);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .prepay-calc-wrap {
        background: #FFFFFF;
        box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.1);
        .top {
            padding: 10px;
            border-top: 1px solid #ECEDF1;
        }
        table {
            min-width: 100%;
            .status {
                width: 90px;
                text-align: center;
            }
            .name {
                width: auto;
                text-align: left;
            }
            .th {
                width: 150px;
                text-align: right;
            }
            .red {
                color: #EB5757;
            }
            .green {
                color: #27AE60;
            }
            .gray {
                color: #828282;
            }
            thead {
                tr {
                    th {
                        height: 50px;
                        font-weight: 600;
                        font-size: 12px;
                        line-height: 30px;
                        color: #1C2D3F;
                        padding-left: 10px;
                        padding-right: 10px;
                        border-bottom: 1px solid #ECEDF1;
                        border: 1px solid #ECEDF1;
                        vertical-align: middle;
                        cursor: pointer;
                        min-width: 55px;
                        white-space: nowrap;
                        &:last-child {
                            padding-right: 10px;
                        }
                        .wrap {
                            position: relative;
                            padding-right: 14px;
                        }
                        .sort-icon {
                            width: 4px;
                            height: 10px;
                            display: inline-block;
                            position: absolute;
                            top: 50%;
                            margin-top: -3px;
                            right: 3px;
                            &.ascend {
                                .down {
                                    path {
                                        fill: #1C2D3F;
                                    }
                                }
                            }
                            &.descend {
                                .up {
                                    path {
                                        fill: #1C2D3F;
                                    }
                                }
                            }
                            svg {
                                display: block;
                            }
                            .up {
                                margin-bottom: 2px;
                            }
                            .down {
                            }
                        }
                    }
                }
            }
            tbody {
                tr {
                    td {
                        height: 50px;
                        font-size: 12px;
                        line-height: 30px;
                        color: #1C2D3F;
                        padding-left: 10px;
                        padding-right: 10px;
                        text-align: right;
                        min-width: 55px;
                        border: 1px solid #ECEDF1;
                        position: relative;
                        &:last-child {
                            padding-right: 10px;
                        }
                        &.prepay {
                            text-align: left;
                        }
                    }
                }
            }
            .tr {
                display: table-row;
                &.show {
                    display: table-row !important;
                }
            }
            .switch {
                min-width: 40px;
                width: 40px;
                border-right: 1px solid #ECEDF1;
                text-align: center;
                padding-left: 0;
                padding-right: 0;
                span {
                    width: 25px;
                    height: 25px;
                    display: inline-block;
                    vertical-align: middle;
                }
                &.empty {
                    border-right-color: transparent;
                }
            }
            .id {
                text-align: left;
            }
            // .for-collapse {
            //     & > td {
            //         height: auto;
            //         padding: 0 !important;
            //     }
            // }
        }
        .edit-wrap {
            position: absolute;
            top: 8px;
            right: 10px;
            .icon {
                cursor: pointer;
                width: 16px;
                height: 16px;
                svg {
                    vertical-align: middle;
                }
            }
            .drop {
                position: absolute;
                background: #FFFFFF;
                border: 1px solid #C2CAD8;
                box-sizing: border-box;
                box-shadow: inset 0px 1px 0px #ECECEC;
                display: flex;
                width: 130px;
                height: 34px;
                right: 0;
                top: 50%;
                margin-top: -9px;
                padding-top: 5px;
                padding-bottom: 5px;
                input {
                    border: none;
                    padding-left: 13px;
                    width: 80px;
                }
                .ok {
                    width: 24px;
                    height: 24px;
                    cursor: pointer;
                }
                .cancel {
                    width: 24px;
                    height: 24px;
                    cursor: pointer;
                }
            }
        }
    }

</style>
